import {Link} from 'react-router-dom';
import {useMemories} from '../api/plants';
import EmptyState from '../components/feedback/EmptyState';
import ErrorBox from '../components/feedback/ErrorBox';
import {SkeletonList} from '../components/feedback/Skeleton';
import Icon from '../components/Icon';
import TellCard from '../components/tell/TellCard';
import {groupByYear, promptSentence, windowLabel} from '../lib/memories';
import {todayLocal} from '../lib/when';

// "This week, other years" (wireframe "last-year"): the tells from this week in earlier years,
// a band per year, and at the end the first "the app asks a question" moment: last year you
// planted out tomatoes this week, done it again?

const DAYS = 7;

export default function MemoriesPage() {
    const memories = useMemories(DAYS);
    const today = memories.data?.today ?? todayLocal();
    const groups = groupByYear(memories.data?.items ?? []);
    const prompt = memories.data?.prompt ?? null;

    const again = prompt ? `/tell/new?${new URLSearchParams({plant: prompt.plantLabel, ...(prompt.placeId ? {place: prompt.placeId} : {}), kind: prompt.kind}).toString()}` : null;

    return (
        <div className="settle-in flex flex-col gap-5">
            <header className="pt-2">
                <Link to="/journal" className="meta mb-1 inline-flex items-center gap-1 no-underline">
                    <Icon name="back" size={16} /> Journal
                </Link>
                <h1 className="display m-0">This week, other years</h1>
                <p className="meta mt-1">{windowLabel(today, DAYS)}</p>
            </header>

            {memories.isPending && <SkeletonList rows={2} kind="card" />}
            {memories.isError && <ErrorBox error={memories.error} onRetry={() => void memories.refetch()} />}

            {memories.isSuccess && groups.length === 0 && (
                <EmptyState icon="calendar" tone="plain" title="Nothing from this week in earlier years.">
                    Today&rsquo;s tells will be waiting here next year.
                </EmptyState>
            )}

            {groups.map(group => (
                <section key={group.year} className="flex flex-col gap-3">
                    <h2 className="band-label m-0 text-ink-2">{group.year}</h2>
                    {group.posts.map(post => (
                        <TellCard key={post.id} post={post} />
                    ))}
                </section>
            ))}

            {prompt && again && (
                <div className="nudge px-4 py-3">
                    {promptSentence(prompt, today)}{' '}
                    <Link to={again} className="font-bold underline-offset-2 hover:underline">
                        Done it again?
                    </Link>
                </div>
            )}
        </div>
    );
}
